// todo : remove ignore statement when password reset modal works again
/* istanbul ignore file */
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { cn } from '@express-labs/raven-tools';
import { Button, Link, Icon, Title } from '@express-labs/raven-ui';
import MyAccountAuxiliaryNav from './subcomponents/MyAccountAuxiliaryNav';
import ExpWhiteInsiderLogo from './ExpWhiteInsiderLogo';
import s from './MyAccount.module.scss';
import LoginContainer from '../../../../containers/LoginContainer/LoginContainer';
import { creditCardDiscount } from '../../../../constants';
import routes from '../../../routes/routes';

export default function MyAccount(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    className,
    containerClassName,
    creditCardName,
    iconCard,
    firstBtnTxt,
    firstBtnPath,
    firstPhrase,
    saveMoneyText,
    onLoginClose,
    secondBtnTxt,
    secondPhrase,
    viewAccountText,
    flagNewTiers,
  } = props;

  const handleClick = useCallback((route) => {
    window.location.assign(route);
  }, []);

  const handleSignInClick = useCallback(() => {

    // UNCOMMENT BELOW TO ENABLE TO MODAL SIGN IN
    // DISABLING AS PASSWORD RESET FROM THE MODAL IS NOT WORKING AS ANTICIPATED
    // setIsModalOpen(true);
    window.location.assign('/login');
  }, []);

  const handleSignUpClick = useCallback(() => {
    handleClick(firstBtnPath);
  }, [firstBtnPath, handleClick]);

  const handleNextCCLinkClick = useCallback(() => {
    handleClick(routes.next.signUp.path);
  }, [handleClick]);

  const handleNextPayBillLinkClick = useCallback(() => {
    handleClick(routes.next.signIn.path);
  }, [handleClick]);

  const handleLoginCloseModal = useCallback(() => {
    if (typeof onLoginClose === 'function') {
      onLoginClose();
    }
    setIsModalOpen(false);
  }, [onLoginClose]);

  const showButtons = useCallback(() => {
    const firstBtnAria = firstBtnTxt.toLowerCase();
    const secondBtnAria = secondBtnTxt.toLowerCase();

    return (
      <>
        <Button
          as="button"
          size="mega"
          theme="light"
          mode="solid"
          className={s.nextBtn}
          onClick={handleSignUpClick}
          aria-label={firstBtnAria}
        >
          {firstBtnTxt}
        </Button>
        <Button
          as="button"
          size="mega"
          theme="light" 
          mode="ghost"
          className={s.nextBtn}
          onClick={handleSignInClick}
          aria-label={secondBtnAria}
        >
          {secondBtnTxt}
        </Button>
      </>
    );
  }, [firstBtnTxt, handleSignInClick, handleSignUpClick, secondBtnTxt]); 

  return (
    <div className={cn(s.container, className)}>
      <div className={s[containerClassName]}>
        <div className={s.logoContainer}>
          <ExpWhiteInsiderLogo />
          {flagNewTiers ? (
            <p className={s.oneLineText}>A world of rewards and access.</p>
          ) : (
            <>
              <div className={s.shop}>{firstPhrase}</div>
              <div className={s.earn}>{secondPhrase}</div>
            </>
          )}
        </div>
        <div className={s.nextBtns}>{showButtons()}</div>
        <div className={s.learnMore}>
          <Link
            as="a"
            theme="light"
            size="body"
            href={routes.next.benefits.path}
          >
            Learn More
          </Link>
        </div>
      </div>
      <Button
        mode="solid"
        as="a"
        size="large"
        theme="light"
        className={s.subContainer}
        onClick={handleNextCCLinkClick}
        aria-label="next credit card"
      >
        <Icon icon={iconCard} />
        <div className={s.description}>
          <Title tag="h5" className={s.cardTitle}>{creditCardName}</Title>
          <p className={s.cardSubTitle}>{saveMoneyText}</p>
        </div>
      </Button>
      <Button
        mode="solid"
        as="a"
        size="large"
        theme="light"
        className={s.subContainer}
        onClick={handleNextPayBillLinkClick}
        aria-label="pay bill"
      >
        <Icon icon="payBill" />
        <div className={s.description}>
          <Title tag="h5" className={s.cardTitle}>Pay Your Bill</Title>
          <p className={s.cardSubTitle}>{viewAccountText}</p>
        </div>
      </Button>
      <MyAccountAuxiliaryNav />
      {isModalOpen && (
        <LoginContainer isModalOpen={isModalOpen} onModalClose={handleLoginCloseModal} />
      )}
    </div>
  );
}

MyAccount.propTypes = {
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  creditCardName: PropTypes.string,
  firstBtnPath: PropTypes.string,
  firstBtnTxt: PropTypes.string,
  firstPhrase: PropTypes.string,
  iconCard: PropTypes.string,
  saveMoneyText: PropTypes.string,
  secondBtnTxt: PropTypes.string,
  secondPhrase: PropTypes.string,
  viewAccountText: PropTypes.string,
  onLoginClose: PropTypes.func,
  flagNewTiers: PropTypes.bool,
};
MyAccount.defaultProps = {
  className: ' ',
  containerClassName: 'insiderLogo',
  creditCardName: 'Express Credit Card',
  firstBtnPath: '/register',
  firstBtnTxt: 'Join for Free',
  firstPhrase: 'Welcome to a hole new world of',
  iconCard: 'insiderCard',
  saveMoneyText: `Get an extra ${creditCardDiscount} off* your next purchase.`,
  secondBtnTxt: 'Sign In',
  secondPhrase: 'rewards and access.',
  viewAccountText: 'View your account or make a payment.',
  onLoginClose: null,
  flagNewTiers: false,
};
